import { xAdd, xMultiply, xSubtract } from 'ml-spectra-processing';
import { checkData2DFid } from '../utilities/checkData2DFid';
export function quadrature(data, options) {
    checkData2DFid(data);
    const { fnMode } = options;
    switch (fnMode) {
        case 'ttpi':
            return ttpiQuadrature(data);
        case 'states':
            return shrQuadrature(data);
        case 'echo':
            return echoQuadrature(data);
        default:
            return {
                re: data.re.z,
                im: data.im.z,
            };
    }
}
function echoQuadrature(data) {
    const { re: { z: reMatrix }, im: { z: imMatrix }, } = data;
    const newRe = [];
    const newIm = [];
    for (let i = 0; i < reMatrix.length; i += 2) {
        let reCosine = reMatrix[i];
        let imCosine = imMatrix[i];
        let reSine = reMatrix[i + 1];
        let imSine = imMatrix[i + 1];
        newRe.push(xSubtract(xMultiply(imSine, -1), imCosine));
        newRe.push(xSubtract(reSine, reCosine));
        newIm.push(xAdd(reSine, reCosine));
        newIm.push(xSubtract(imSine, imCosine));
    }
    return { re: newRe, im: newIm };
}
function shrQuadrature(data) {
    const { re, im } = data;
    return { re: re.z, im: im.z };
}
function ttpiQuadrature(data) {
    const newRe = [];
    const newIm = [];
    const { re: { z: reMatrix }, im: { z: imMatrix }, } = data;
    for (let i = 0; i < reMatrix.length; i++) {
        newRe.push(i % 2 ? reMatrix[i].slice() : xMultiply(reMatrix[i], -1));
        newIm.push(i % 2 ? imMatrix[i].slice() : xMultiply(imMatrix[i], -1));
    }
    return { re: newRe, im: newIm };
}
//# sourceMappingURL=quadrature.js.map